var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.9844H16C16.7956 12.9844 17.5587 12.6683 18.1213 12.1057C18.6839 11.5431 19 10.78 19 9.98438C19 9.18874 18.6839 8.42567 18.1213 7.86306C17.5587 7.30045 16.7956 6.98438 16 6.98438H15.975C15.9908 6.81818 15.9992 6.65134 16 6.48438C15.9962 5.15774 15.5131 3.87716 14.6396 2.87867C13.7661 1.88017 12.5611 1.23105 11.2467 1.05094C9.93236 0.870825 8.59718 1.17186 7.48727 1.89856C6.37736 2.62527 5.56752 3.72866 5.207 5.00538C5.137 5.00138 5.071 4.98438 5 4.98438C3.93913 4.98438 2.92172 5.40581 2.17157 6.15596C1.42143 6.9061 1 7.92352 1 8.98438C1 10.0453 1.42143 11.0627 2.17157 11.8128C2.92172 12.563 3.93913 12.9844 5 12.9844H7.167M10 14.9844V5.98438M10 5.98438L8 7.98438M10 5.98438L12 7.98438",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileGrey);
export default __webpack_public_path__ + "static/media/upload-file-grey.5d9374e5cd0250e48e8f3794942bbb58.svg";
export { ForwardRef as ReactComponent };